import { FileUploadProps } from "@/components/chatform/fileupload";
import React from "react";
import { StackSimple, X, Image as ImageIcon, Warning } from "@phosphor-icons/react";
import { isValidFile, isValidImage } from "@/lib/utils";

export const FileUploadPreview = ({ fileUploadState, setFileUploadState }: FileUploadProps) => {
    const ext = fileUploadState?.filename?.split(".").pop()?.toLowerCase();
    if (fileUploadState?.error !== undefined) {
        return (
            <div className={"text-sm text-red-700 flex flex-row items-start mb-4 pl-3"}>
                <div className={"pr-2"}>
                    <Warning size={24} />
                </div>
                <div>{fileUploadState.error}</div>
            </div>
        );
    }
    return (
        <>
            {fileUploadState !== undefined && (
                <div className={"flex flex-row items-start mb-4 pl-3"}>
                    {isValidImage(ext || "") && (
                        <div className={"pr-2 translate-y-[-1px]"}>
                            <ImageIcon size={24} data-testid="image-icon" />
                        </div>
                    )}
                    {isValidFile(ext || "") && (
                        <div className={"pr-2"}>
                            <StackSimple size={24} data-testid="file-icon" />
                        </div>
                    )}
                    <div className={"text-sm"}>{fileUploadState.filename}</div>
                    <div className={"pl-2 pt-0.5"}>
                        <X
                            size={18}
                            className={
                                "cursor-pointer opacity-30 hover:opacity-100 transition-opacity"
                            }
                            onClick={() => setFileUploadState(undefined)}
                            data-testid="close-icon"
                        />
                    </div>
                </div>
            )}
        </>
    );
};
